<template>
  <div class="content_main" @scroll="handleScroll">
    <div class="banner animate__animated animate__bounceInLeft">
      <img src="../../assets/images/n-banner02.jpg" alt="">
    </div>
    <div class="bg animate__animated animate__fadeInUp">
      <div class="module-title">
        O2O票务一体化系统
        <span>O2O ticketing integration system</span>
      </div>
      <div class="module-title">
        <div class="mt_line"></div>
        产品介绍
        <span>Product introduction</span>
      </div>
      <div class="product_introduct_text content">
        <div>
          020一体化系统是一款基于Web，SOA架构，软硬件一体化、线上线下一体化的、可扩展的智慧综合管理解决方案，集票务管理、系统管理、查询统计、报表中心、大屏展示系统于一体，可在整个景区运营中实现协作的、集成的和基于票务驱动的电子化流程。
        </div>
      </div>
      
      <div class="module-title">
        <div class="mt_line"></div>
        子系统
        <span>Subsystem</span>
        <div class="product_z_system content">
          <div class="tag">
            <img src="./image/dzsw.png" alt="">
            <span>电子商务系统</span>
          </div>
          <div class="tag">
            <img src="./image/dzsp.png" alt="">
            <span>电子售票系统</span>
          </div>
          <div class="tag">
            <img src="./image/dzjp.png" alt="">
            <span>电子检票系统</span>
          </div>
          <div class="tag">
            <img src="./image/zzpwxt.png" alt="">
            <span>自助票务系统</span>
          </div>
          <div class="tag">
            <img src="./image/smyy.png" alt="">
            <span>实名预约系统</span>
          </div>
          <div class="tag">
            <img src="./image/rlsb.png" alt="">
            <span>人脸识别系统</span>
          </div>
          <div class="tag">
            <img src="./image/zhpw.png" alt="">
            <span>综合票务数据中心</span>
          </div>
          <div class="tag">
            <img src="./image/jszx.png" alt="">
            <span>结算中心</span>
          </div>
          <div class="tag">
            <img src="./image/jhzf.png" alt="">
            <span>聚合支付系统</span>
          </div>
          <div class="tag">
            <img src="./image/zhmh.png" alt="">
            <span>综合门户系统</span>
          </div>
          <div class="tag">
            <img src="./image/dydl.png" alt="">
            <span>导游导览系统</span>
          </div>
          <div class="tag">
            <img src="./image/xnly.png" alt="">
            <span>虚拟旅游系统</span>
          </div>
        </div>
      </div>
    </div>
    <div class="module-title">
      <div class="mt_line"></div>
      效果展示
      <span>Effect display</span>
    </div>
    <div class="content zhyx_img">
      <img src="./image/bdc.png" alt="">
    </div>
    <div class="footer">
      <footerPage />
    </div>
  </div>
</template>

<script>
import footerPage from '../../components/footer/footer'
export default {
  components:{
    footerPage
  },
  methods: {
    handleScroll(e){
      console.log(e)
    }
  },
}
</script>

<style scoped lang='less'>
@import '../../assets/css/content.less';
.content_main{
  height: 100%;
  width: 100%;
  
  // background-image: url('../../assets/images/image1.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.bg{
  padding-bottom: 50px;
}
.banner{
  width: 100%;
  img{
    width: 100%;
    border: 0;
    display: block;
  }
}
.title{
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  h4{
    font-size: 30px;
  }
}
.module-title {
  margin-top: 40px;
  margin-bottom: 40px;
  font-size: 26px;
  color: #0080cc;
  text-align: center;
  font-weight: normal;
  span {
    display: block;
    color: #818181;
    text-transform: uppercase;
    font-size: 19px;
    margin-top: 5px;
  }
}
.mt_line {
  width: 100%;
  height: 83px;
  margin-bottom: 20px;
  background: url('./../../../static/images/ai/btline.png') no-repeat center top;
}
.product_introduct{
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 2rem;
  background: #f5f5f5;
  margin: 0 10%;
  h4{
    font-size: 30px;
    line-height: 80px;
  }
}
.product_introduct_text{
  margin-top: 2rem;
  div{
    font-size: 18px;
    line-height: 40px;
    text-indent:3rem;
    margin-bottom: 20px;
  }
}
.product_z_system{
  margin-top: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .tag{
    width: 29.333%;
    margin: 1% 2%;
    height: 50px;
    color: #000;
    line-height: 50px;
    text-align: center;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 4%;
    img{
      height: 90%;
    }
    span{
      width: 80%;
      display: inline-block;
      text-align: left;
      font-size: 14px;
    }
  }
}
.image_box{
  margin: 40px 0;
  img{
    width: 100%;
    margin: 20px 0;
  }
}
.zhyx_img{
  img{
    width: 100%;
  }
}
.footer{
  width: 100%;
  margin-top: 20px;
}
</style>
